<template>
  <div>
    <div class="outrasInfoBox_header">
      Documentos
    </div>
    <div class="px-2">
      <small>Adicione documentos que deseja declarar no registro.</small>

      <form name="formAddDocs">
        <Documentos :read-only="readOnly"
                    :prop-data="data"
                    :pessoa-id="localData.pessoa_id"
                    :documentos="localData.documentos"
                    :tipo-registro="localData.registro.tipo_registro"
                    @DocumentoAdded="getDocumentos"
                    @DocumentoRemoved="removeDocumento" />

        <div class="form-group">
          <span v-if="!propLegado"
                class="custom-control custom-switch custom-control-inline mr-4">
            <input id="deixa_bens"
                   v-model="localData.deixa_bens"
                   class="custom-control-input"
                   name="deixa_bens"
                   type="checkbox"
                   @change="updateObito"
                   @keyup.enter="changeInputs('bens')">
            <label class="custom-control-label"
                   for="deixa_bens">Deixa Bens</label>
          </span>

          <span v-if="!propLegado"
                class="custom-control custom-switch custom-control-inline mr-4">
            <input id="deixa_testamento"
                   v-model="localData.deixa_testamento"
                   class="custom-control-input"
                   name="deixa_testamento"
                   type="checkbox"
                   @change="updateObito"
                   @keyup.enter="changeInputs('testamento')">
            <label class="custom-control-label"
                   for="deixa_testamento">Deixa Testamento</label>
          </span>

          <span v-if="!propLegado"
                class="custom-control custom-switch custom-control-inline mr-4">
            <input id="reservista"
                   v-model="localData.reservista"
                   class="custom-control-input"
                   name="reservista"
                   type="checkbox"
                   @change="updateObito"
                   @keyup.enter="changeInputs('reservista')">
            <label class="custom-control-label"
                   for="reservista">Reservista</label>
          </span>

          <span class="custom-control custom-switch custom-control-inline mr-4">
            <input id="eleitor_ativo"
                   v-model="localData.eleitor_ativo"
                   class="custom-control-input"
                   name="eleitor_ativo"
                   type="checkbox"
                   @change="updateObito"
                   @keyup.enter="changeInputs('eleitor')">
            <label class="custom-control-label"
                   for="eleitor_ativo">Eleitor Ativo</label>
          </span>
        </div>
      </form>
    </div>

    <div v-if="!propLegado">
      <Filhos
        v-if="localData.tipo_registro_obito != 'NT'"
        :read-only="readOnly"
        class="mt-3"
        :prop-data="localData"
        @deixaFilhos="(value) => deixaFilhos(value)"
        @filhoAdded="getFilhos"
        @filhoRemoved="(filho, index) => removeFilho(filho, index)"
        @filhoUpdated="updateFilho" />

      <Partes
        prop-header="Partes"
        :read-only="readOnly"
        :partes="localData.registro.partes"
        :registro-id="localData.registro_id"
        :prop-cartorio="propCartorio"
        :prop-correcoes="propCorrecoes"
        prop-tipo="OBITO"
        :data="data"
        @deleteError="deleteError"
        @DocumentoRemoved="removeDocumento"
        @ParteAdded="getPartes"
        @ParteRemoved="removeParte"
        @ParteUpdated="updateParte"
        @removeEndereco="removeEnderecoParte"
        @verifyParte="verifyParte" />
      <div class="outrasInfoBox_header d-inline-flex justify-content-between w-100 align-items-center">
        Informações Adicionais
        <button class="btn btn-sm btn-primary"
                @click="getComplemento()">
          Mesclar
        </button>
      </div>
      <div class="row">
        <div class="col">
          <div class="form-group mx-2">
            <label class="label"
                   for="complemento" />
            <b-form-textarea
              id="complemento"
              v-model="localData.registro.complemento"
              class="text-justify"
              placeholder=""
              rows="4"
              no-resize
              @change="changed" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  /* components */
  import Filhos from './Sessoes/Filhos'
  import Partes from './Sessoes/Partes'
  import Documentos from './Sessoes/Documentos.vue'

  /* helpers */
  import { getEstadoCivilBySexo } from '@/helpers/estadoCivil'

  /* filters */
  import { firstCapitalize } from '@/filters/filters'

  /* services */
  import ObitoService from "@/services/Registros/Obito"


  export default {
    name: 'PassoOutrasInfo',
    components: { Filhos, Partes, Documentos },
    props: {
      data: { type: Object },
      readOnly: { type: Boolean, default: ()=> false},
      propCartorio: { type: Object, default: () => { return {} } },
      propCorrecoes: {type: Object, default: () => ({})},
      propLegado: {type: Boolean, default: false}
    },
    data () {
      return {
        deleteds: { pessoaDocumentos: [], partes: [], filhoDeixado: [], pessoaEnderecos: [] },
        localData: {
          deixa_bens: false,
          deixa_testamento: false,
          reservista: null,
          filhoDeixado: [],
          eleitor_ativo: null,
          documentos: [],
          testemunhas: [],
          declarantes: []
        },
      }
    },
    watch: {
      data () {
        this.localData = { ...this.data }
      }
    },
    created () {
      this.localData = { ...this.data }
    },
    mounted () {
      document.querySelector(`.selectDocumentos`).focus()
      this.checkEleitorReservista()
    },
    methods: {
      changed () {
        this.localData.deleteds = this.deleteds
        this.$emit('changed', this.localData)
      },
      async updateObito (event) {
        const data = {
          deixa_bens: this.localData.deixa_bens,
          deixa_testamento: this.localData.deixa_testamento,
          reservista: this.localData.reservista,
          eleitor_ativo: this.localData.eleitor_ativo
        }

        if (!this.readOnly) {
          const updated = await ObitoService.updateObito(this.$route.params.id, data, 0)
        }
        this.changed()
      },

      getDocumentos (documento) {
        this.localData.documentos.push(documento)
        this.changed()
      },

      removeDocumento (documento) {
        this.localData.documentos.splice(documento.localId, 1)
        this.deleteds.pessoaDocumentos.push(documento.pessoa_documento_id)
        this.$emit('documentoRemoved', documento)
      },

      deixaFilhos (value) {
        this.localData.deixa_filhos = value

        if (!value) {
          this.localData.filhoDeixado.forEach(filho => {
            if (filho.filho_deixado_id >= 0) {
              this.deleteds.filhoDeixado.push(filho.filho_deixado_id)
              this.$emit('filhoDeixadoRemoved', filho)
            }
          })
          this.localData.filhoDeixado = []
        }

        this.changed()
      },

      getFilhos (filho) {
        this.localData.filhoDeixado.push(filho)
        this.localData.deixa_filhos = (this.localData.filhoDeixado.length > 0)
        this.changed()
      },

      removeFilho (filho, index) {
        this.localData.filhoDeixado.splice(index, 1)
        !!filho.filho_deixado_id && this.deleteds.filhoDeixado.push(filho.filho_deixado_id)

        this.localData.deixa_filhos = (this.localData.filhoDeixado.length > 0)
        this.changed()
        this.$emit('filhoDeixadoRemoved', filho)
      },

      updateFilho (filho) {
        this.localData.filhoDeixado[filho.localId] = filho
        this.localData.deixa_filhos = (this.localData.filhoDeixado.length > 0)
        this.changed()
      },

      async getPartes (parte) {
        this.localData.registro.partes.push(parte)

        setTimeout(() => {
          const btnConfirm = document.querySelector('.swal2-confirm')

          if (btnConfirm) btnConfirm.focus()
        }, 300)

        await this.displaySuccess(null, 'Parte adicionada com sucesso!')

        const btn = document.querySelector('.btn-add-parte')

        if (btn) btn.focus()

        //Envia um objeto vazio para impedir que seja adicionada a mesma parte duas vezes
        this.$emit('verifyParte', {})

        this.changed()
      },

      async removeParte (parte, localId) {
        this.localData.registro.partes = this.localData.registro.partes.filter((pess, index) => index != localId )
        this.deleteds.partes.push(parte.parte_id)

        setTimeout(() => {
          const btnConfirm = document.querySelector('.swal2-confirm')

          if (btnConfirm) btnConfirm.focus()
        }, 300)

        await this.displaySuccess(null, "Parte removida com Sucesso!")

        const btn = document.querySelector('.btn-add-parte')

        if (btn) btn.focus()

        this.$emit('parteRemoved', parte)
        this.changed()
      },

      async updateParte (parte) {
        this.localData.registro.partes[parte.localId] = parte

        setTimeout(() => {
          const btnConfirm = document.querySelector('.swal2-confirm')

          if (btnConfirm) btnConfirm.focus()
        }, 300)

        await this.displaySuccess(null, "Parte atualizada com Sucesso!")

        const btn = document.querySelector('.btn-add-parte')

        if (btn) btn.focus()

        this.changed()
      },

      checkEleitorReservista () {
        const { nacionalidade_codigo, idade, sexo } = this.data
        const { eleitor_ativo, reservista } = this.localData

        /* caso for brasileiro e tiver mais que 16 anos será um eleitor ativo */
        if (eleitor_ativo === null && idade > 15 && nacionalidade_codigo == 76) {
          this.localData.eleitor_ativo = true
        } else {
          this.localData.eleitor_ativo = eleitor_ativo
        }

        /* caso tenha entre 17 a 45 anos e for do sexo masculino será considerado reservista */
        if (reservista === null && (idade > 16 && idade < 46) && nacionalidade_codigo === 76 && sexo == "M") {
          this.localData.reservista = true
        } else {
          this.localData.reservista = reservista
        }

        this.$emit('changed', this.localData)
      },
      removeEnderecoParte (endereco) {
        if (endereco.endereco_id) {
          this.deleteds.pessoaEnderecos.push(endereco.endereco_id)
          this.$emit('deleteAddress', endereco)
        }
      },

      verifyParte (parte) {
        this.$emit('verifyParte', parte)
      },
      deleteError (error) {
        this.$emit('deleteError', error)
      },
      changeInputs (name) {
        if (name == 'bens') this.localData.deixa_bens = !this.localData.deixa_bens
        else if (name == 'testamento') this.localData.deixa_testamento = !this.localData.deixa_testamento
        else if (name == 'reservista') this.localData.reservista = !this.localData.reservista
        else if (name == 'eleitor') this.localData.eleitor_ativo = !this.localData.eleitor_ativo

        this.updateObito()
      },
      displaySuccess (title, text, html) {
        objSwal.success.title = title
        objSwal.success.text = text
        objSwal.success.html = html

        return Swal.fire(objSwal.success).then((res) => {
          objSwal.success.title = ''
          objSwal.success.text = ''
          objSwal.success.html = ''

          return res
        })
      },

      getConjuge () {
        const estado_civil = this.localData.pessoa && this.localData.pessoa.estadoCivil ? this.localData.pessoa.estado_civil : this.localData.estado_civil

        if (['IGNORADO', 'IGNORADA', 'OUTROS', 'OUTRAS', 'SOLTEIRO', 'SOLTEIRA'].indexOf(estado_civil) != -1) return

        const casamento = this.localData.registro.anteriores.find(anterior => (anterior.tipo_registro === 'C' || anterior.tipo_registro === 'CR') && anterior.registro_atual)

        if (casamento) {
          return casamento.conjuge
        }
      },

      getComplemento ()  {
        const estado_civil = this.localData.pessoa && this.localData.pessoa.estado_civil ? this.localData.pessoa.estado_civil : this.localData.estado_civil
        const sexo = this.localData.pessoa ? this.localData.pessoa.sexo : this.localData.sexo
        const textConjuge = this.getConjuge() ? `${estado_civil && ['CASADO','CASADA'].indexOf(estado_civil) != -1 ? ' com' : ' de'} ${this.getConjuge()}` : ''
        const showEstadoCivil = estado_civil && this.verifyEstadoCivil(estado_civil)

        this.localData.registro.complemento =
          `${sexo && sexo === "F" ? "A falecida" : "O falecido"} ${this.localData.deixa_testamento ? 'deixou testamento' : 'não deixou testamento'}, ` +
          `${this.localData.deixa_bens ? 'deixando bens' : 'não deixando bens'}. ` +
          `${showEstadoCivil ? (this.tratarEstadoCivil(estado_civil) + textConjuge + '. ') : ''}` +
          `${this.localData.filhoDeixado && this.localData.filhoDeixado.length ? `Filho(s) do(a) falecido(a) ${this.tratarFilhos(this.localData.filhoDeixado)}.` : ` Não deixa filhos.`} ` +
          `O declarante ignora os dados faltantes ao assento.`

        this.changed()
      },

      tratarEstadoCivil (estadoCivil) {
        const sexo = this.localData.pessoa ? this.localData.pessoa.sexo : this.localData.sexo

        const estado_civil = getEstadoCivilBySexo(
          estadoCivil,
          sexo
        )

        if (['VIUVO', 'VIUVA'].indexOf(estado_civil) !== -1) {
          return firstCapitalize(estado_civil.replace('U', 'Ú'))
        } else if (['IGNORADO', 'IGNORADA', 'OUTROS', 'OUTRAS'].indexOf(estado_civil) !== -1) {
          return 'Estado civil ' + estado_civil.toLowerCase()
        } else {
          return firstCapitalize(estado_civil)
        }
      },
      verifyEstadoCivil (estado) {
        const estadosCivis = [
          'SOLTEIRO',
          'SOLTEIRA',
          'IGNORADO',
          'IGNORADA',
          'OUTROS',
          'OUTRAS'
        ]

        if (!estadosCivis.includes(estado)) return true

      },
      tratarFilhos (filhos) {
        const tipos_idades = {
          'A': 'anos',
          'M': 'meses',
          'D': 'dias'
        }

        if (filhos && filhos.length) {
          let fraseFilhos = []

          filhos.forEach(filho => {
            if ((filho.idade || filho.idade_tipo == 'I') && !filho.interditado) {
              fraseFilhos.push(`${ firstCapitalize(filho.nome) } ${ filho.idade_tipo == 'I' ? 'com idade ignorada' : `com ${ filho.idade } ${tipos_idades[filho.idade_tipo]}` }`)
            } else if (filho.interditado) {
              fraseFilhos.push(`${ firstCapitalize(filho.nome) } interditado(a)`)
            } else {
              fraseFilhos.push(`${ firstCapitalize(filho.nome) }`)
            }
          })

          const frase = filhos.length > 1 ? fraseFilhos.join(', ') : fraseFilhos.join(', ')

          return frase
        }
      }
    }
  }
</script>

<style lang="scss">
  @import '../../../../scss/_utilities/exports';

  .outrasInfoBox {
    &_header {
      @extend %titleBox;
      background-color: $color-gray-light;
    }
  }
</style>
